import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Typography from 'kingpin/atoms/Typography';
import useUser from '../../../../hooks/useUser';
import getUserDisplayName from '../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UsersProvider/getUserDisplayName';

const Div = styled.div`
  background-color: var(--color-bg-muted);
  padding: 8px;
`;

const LastUpdatedAt = ({
  target,
}: {
  target: Targets.Wizard.DataTypeTarget;
}) => {
  const { user } = useUser(target.updatedBy);
  const date = moment(target.updatedOn).format('YYYY-MM-DD');

  return (
    <Div>
      <Typography.Body type="Body 12">
        {`Last Updated: ${date} by ${user ? getUserDisplayName(user) : '-'}`}
      </Typography.Body>
    </Div>
  );
};

export default LastUpdatedAt;
